import type { Trip } from '../types';

/**
 * Everything the server reads to pick each day's weather point: the dates and,
 * per destination, where it is and how many nights it takes. The weather hooks
 * refetch when this changes — keyed on `tripId` alone, reordering destinations
 * kept showing the old strip until a reload.
 */
export function tripWeatherKey(trip: Pick<Trip, 'startDate' | 'endDate' | 'destinations'>): string {
  const legs = (trip.destinations ?? []).map(d => `${d.latitude},${d.longitude},${d.nights}`);
  return [trip.startDate, trip.endDate, ...legs].join('|');
}
